import { IBreadcrumbs, IPreFooter, Seo } from '@sravni/types/lib/seo';

export const DEFAULT_METADATA = {
    breadcrumbs: [] as IBreadcrumbs[],
    prefooter: [] as IPreFooter[],
    sideBlock: {
        links: [] as any[],
    },
    schema: {},
    heading: '',
    headingTemplate: '',
    canonical: 'https://www.sravni.ru/',
    meta: {},
    contentBlocks: [] as any[],
} as Seo;
